import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=5c16eb2b&scoped=true"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=5c16eb2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16eb2b",
  null
  
)

export default component.exports